export default __webpack_public_path__ + "static/media/Elio 5.86b80985.jpg";